import { useEffect } from 'react'
import { useHistory, Switch, Route } from 'react-router-dom'
import { useLocation } from 'react-use'
import { Loader } from '@components/v2/loader'
import { useQueryMfaCheck } from './hooks/useQueryMfaCheck'
import { Login } from './login'
import { Setup } from './setup'
import { useMfaStore } from './store/useMfaStore'

export function Mfa() {
  const location = useLocation()
  const history = useHistory()
  const queryParams = new URLSearchParams(location.search)
  const email = queryParams.get('email')
  const token = queryParams.get('mfa_token')

  const { isSetupSuccessful } = useMfaStore()
  const { data, isLoading, isFetched } = useQueryMfaCheck({ email, token })

  useEffect(() => {
    if (isLoading || !isFetched) return

    if (data?.mfa_enabled) {
      history.push(`/auth/mfa/login${location.search}`)
      return
    }

    if (!isSetupSuccessful) {
      history.push(
        `/auth/mfa/setup${location.search || '?'}&email=${encodeURIComponent(
          email!,
        )}&mfa_token=${token}`,
      )
    }
  }, [data?.mfa_enabled, isLoading, isFetched, email, token, location?.search, isSetupSuccessful])

  return (
    <>
      {isLoading && (
        <div className="w-full flex justify-center">
          <Loader className="w-7 h-7" />
        </div>
      )}
      <Switch>
        <Route path="/auth/mfa/setup">
          <Setup />
        </Route>
        <Route path="/auth/mfa/login">
          <Login />
        </Route>
      </Switch>
    </>
  )
}
